import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { DialogoImportacao } from '../../componentes/importacao';
import { invalidarContas, type TipoDocumento } from './tipos';

/** Base REST do importador de títulos de cada aba (framework de importação do núcleo, fase 2, W14). */
export const caminhoImportarTitulos = (tipo: TipoDocumento) => `/contas/importacoes/${tipo === 'fatura' ? 'receber' : 'pagar'}`;

/**
 * Fase 2, W7 (P5) e W14: importação de títulos pelo diálogo do framework do núcleo (`DialogoImportacao`): colunas aceitas,
 * "Baixar modelo", prévia antes de gravar (nada é gravado), erros por linha com os parceiros parecidos pelo nome, já
 * importados, baixas e perdas no resultado. A regra da linha é a da W7 (`modules/contas/src/documento/importacao.ts`).
 */
export function ImportarTitulos({ aberto, tipo, aoFechar }: { aberto: boolean; tipo: TipoDocumento; aoFechar: () => void }) {
  const { t } = useTranslation('contas');
  const qc = useQueryClient();
  return <DialogoImportacao aberto={aberto} aoFechar={aoFechar} caminho={caminhoImportarTitulos(tipo)} titulo={t('w7.importarTitulo')} aoConcluir={() => void invalidarContas(qc)} />;
}
